import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-list.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-list.component.css?ngResource";
import { Component } from '@angular/core';
let CalciteListComponent = class CalciteListComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
CalciteListComponent = __decorate([
    Component({
        selector: 'lib-calcite-list',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteListComponent);
export { CalciteListComponent };
